import { useCallback } from 'react';

import type { PaywallIntentParams } from './types';

class Content {
	static paywallIntent: PaywallIntentParams | undefined = undefined;
}

export const useNeedsToShowNeuronsPaywall = () => {
	const setNeedsToShowNeuronsPaywall = useCallback(
		(state: PaywallIntentParams | undefined) => {
			Content.paywallIntent = state;
		},
		[]
	);

	return {
		neuronsPaywallIntent: Content.paywallIntent,
		setNeedsToShowNeuronsPaywall,
	};
};
